<template>
  <div>
    <div class="mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="row" v-if="houses.length >= 2">
            <div class="col-xl-12 col-md-12">
              <h2 class="subTitle">Seleziona la proprietà: </h2>
              <v-select :options="houses" v-on:input="changeEvent"></v-select>
            </div>
            <div class="col-xl-12 col-md-12 mt-4" v-if="house_id">
              <h2 class="font-weight-bold mb-4"><i class="fas fa-home"></i> {{ house_label }}</h2>
              <div class="row">
                <div class="col-xl-6 mb-4 mobileCard">
                  <div class="card bg-light">
                    <netto-proprietario v-bind:house-id="house_id" v-bind:year="year"
                                        :key="componentKeyGrafico"></netto-proprietario>
                  </div>
                </div>
                <div class="col-xl-6 mb-4 mobileCard">
                  <div class="card bg-light">
                    <numero-notti v-bind:house-id="house_id" v-bind:year="year"
                                         :key="componentKeyGraficoTwo"></numero-notti>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="col-xl-12 col-md-12" v-if="house_id">
              <h2 class="font-weight-bold mb-4"><i class="fas fa-home"></i> {{ house_label }}</h2>
              <div class="row">
                <div class="col-xl-6 mb-4">
                  <div class="card bg-light">
                    <netto-proprietario v-bind:house-id="house_id"
                                        :key="componentKeyGrafico"></netto-proprietario>
                  </div>
                </div>
                <div class="col-xl-6 mb-4">
                  <div class="card bg-light">
                    <numero-notti v-bind:house-id="house_id" v-bind:year="year"
                                  :key="componentKeyGraficoTwo"></numero-notti>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="col-lg-4 mt-4" v-if="house_id">

        </div>
        <div class="col-lg-4 text-center mt-4" v-if="house_id">
          <h3><i @click="removeYear()" class="mr-50 fas fa-arrow-circle-left"></i> {{ year }} <i @click="addYear()"
                                                                                                 class="ml-50 fas fa-arrow-circle-right"></i>
          </h3>
        </div>
        <div class="col-lg-4 mt-4" v-if="house_id">

        </div>
      </div>
      <div class="contentCards p-15 mt-5" v-if="house_id">
        <house-cards v-bind:house-id="house_id" v-bind:year="year" :key="componentKeyDati"></house-cards>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListHouses",
  props: ['ownerId'],
  data: function () {
    return {
      componentKeyGrafico: 0,
      componentKeyGraficoTwo: 0,
      componentKeyDati: 0,
      year: new Date().getFullYear(),
      house_id: '',
      house_label: '',
      houses: []
    }
  },
  methods: {
    changeEvent(a) {
      this.forceRerenderGrafici()
      this.forceRerenderDati()
      if (a) {
        this.house_id = a.code;
        this.house_label = a.label;
      } else {
        this.house_id = '';
      }
    },
    forceRerenderDati() {
      this.componentKeyDati += 1;
    },
    forceRerenderGrafici() {
      this.componentKeyGrafico += 1;
      this.componentKeyGraficoTwo += 1;
    },
    addYear() {
      this.year = this.year + 1;
      this.forceRerenderDati()
    },
    removeYear() {
      this.year = this.year - 1;
      this.forceRerenderDati()
    },
    getHouses() {
      axios.get('/api/get-owner-houses/' + this.ownerId)
          .then(response => {
                this.houses = response.data.body;
                if (this.houses.length < 2) {
                  this.house_id = this.houses[0].code;
                  this.house_label = this.houses[0].label;
                }
              }
          )
    }
  },
  mounted() {
    this.getHouses()
  }
}
</script>

<style scoped>
i, h3 {
  color: #29235C !important;
}

i:hover {
  cursor: pointer;
  color: #E94E1B !important;
}

.mr-50 {
  margin-right: 50px !important;
}

.ml-50 {
  margin-left: 50px !important;
}

.subTitle {
  font-size: 16px !important;
}
</style>